import { identicon } from '@dicebear/collection';
import { createAvatar } from '@dicebear/core';
import { useQuery } from '@tanstack/react-query';
import { getRankingData } from 'api/rankingApi';
import { useUser } from 'context/UserContext';
import { titler } from 'helpers/titler';
import Loading from 'pages/components/Loading';
import React from 'react';
import RankingObject from './RankingObject';
import { toast } from 'react-toastify';
import { Navigate } from 'react-router-dom';

export const getPosition = (username, ranking) => {
  for (let i = 0; i < ranking.length; i++) {
    if (ranking[i].username === username) {
      return i + 1; // Position in array (1-based index)
    }
  }
  return ''; // Username not found
};

const Ranking = () => {
  const user = useUser();
  titler('Classifica');

  const userTeamLogo = createAvatar(identicon, {
    seed: user.team.name ? user.team.name : '',
    size: 100
  }).toDataUriSync();

  const {
    data: ranking,
    isLoading,
    isError,
    error
  } = useQuery({
    queryKey: ['rankingData'],
    queryFn: getRankingData
  });

  if (isError) {
    toast.error(error.message);
    return <Navigate to="/classe" />;
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      {user.team.name && (
        <div className="text-center">
          <h4 className="mb-0 text-primary p-2">Posizione</h4>
          <h2 className="mb-0 text-primary fw-bold">
            {getPosition(user.username, ranking)}
          </h2>
          <div className="p-3 h-100">
            <div className="avatar avatar-4xl mb-3">
              <img
                className="shadow-sm bg-light"
                src={userTeamLogo}
                alt=""
                width="100"
              />
            </div>
            <h5 className="mb-1">
              <a href="#">{user.team.name}</a>
            </h5>
            <h6 className="mb-1 text-700">{user.username}</h6>
          </div>
        </div>
      )}

      {ranking.map(function (rankingTeam, index) {
        return (
          <RankingObject
            team={rankingTeam.team.name}
            username={rankingTeam.username}
            points={rankingTeam.score}
            position={index + 1}
            key={index}
          />
        );
      })}
    </>
  );
};

export default Ranking;
